import { NO_OP_MESSAGE__NATIVE } from 'components/LocalNotifications/utils/constants';

import { SendNotificationStateDataToBackendFunc } from '../types';

export const sendNotificationStateDataToBackend: SendNotificationStateDataToBackendFunc = () => {
  throw Error(NO_OP_MESSAGE__NATIVE);
};
